import type { FormConfig } from '#types/config/components/form'
import type { RecursivePartial } from '#types/utils'

export default {
  cancelButtonVariant: 'secondary'
} satisfies RecursivePartial<FormConfig['addAddress']>
